export default "__VITE_ASSET__CGZETW51__"